import { Points } from '@infl-ts/ui-advocate-components';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChallengeBarContainer = function ChallengeBarContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      display: 'flex',
      height: 1,
      width: 1,
      justifyContent: 'center',
      px: 2,
      py: {
        xs: 1,
        md: 2
      }
    },
    "data-element": "Box",
    "data-component": "ChallengeBarContainer",
    "data-source-file": "challenge-bar.tsx",
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 1,
        width: 1,
        maxWidth: 1196,
        mx: {
          xs: 0,
          md: 3
        }
      },
      "data-element": "Box",
      "data-component": "ChallengeBarContainer",
      "data-source-file": "challenge-bar.tsx",
      children: children
    })
  });
};
export var ChallengeBar = function ChallengeBar(_ref2) {
  var _ref2$challenge = _ref2.challenge,
      id = _ref2$challenge.id,
      headline = _ref2$challenge.headline,
      stageType = _ref2.stageType,
      points = _ref2.points,
      handleOpenChallenge = _ref2.handleOpenChallenge;
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(ChallengeBarContainer, {
    "data-element": "ChallengeBarContainer",
    "data-component": "ChallengeBar",
    "data-source-file": "challenge-bar.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: {
          xs: 'column',
          md: 'row'
        },
        width: 1
      },
      "data-element": "Box",
      "data-component": "ChallengeBar",
      "data-source-file": "challenge-bar.tsx",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: isMobile ? 'h5' : 'h3',
        "data-element": "Typography",
        "data-component": "ChallengeBar",
        "data-source-file": "challenge-bar.tsx",
        children: headline
      }), /*#__PURE__*/_jsxs(Typography, {
        variant: isMobile ? 'subscript' : 'body1',
        sx: {
          display: 'flex',
          alignItems: 'center',
          ml: {
            xs: 0,
            md: 'auto'
          },
          mr: {
            xs: 1,
            md: 2
          }
        },
        "data-element": "Typography",
        "data-source-file": "challenge-bar.tsx",
        children: [match(stageType)["with"]('DiscussionReplyStage', function () {
          return t('Reply to this discussion to earn');
        }).otherwise(function () {
          return '';
        }), /*#__PURE__*/_jsx(Points, {
          variant: isMobile ? 'subscript' : 'h5',
          points: points,
          iconSize: "inherit",
          sx: {
            ml: 1.5
          },
          "data-element": "Points",
          "data-source-file": "challenge-bar.tsx"
        })]
      })]
    }), /*#__PURE__*/_jsx(Button, {
      sx: {
        minWidth: 'fit-content'
      },
      variant: "text",
      size: isMobile ? 'small' : 'large',
      onClick: function onClick() {
        return handleOpenChallenge(id);
      },
      "data-element": "Button",
      "data-source-file": "challenge-bar.tsx",
      children: isMobile ? t('Open') : t('Back to Challenge')
    })]
  });
};